import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import { DetailsComponent } from '../details/details.component';
import { PremiumUser } from '../core/premiumUser.guard';
import { StandardUser } from '../core/standardUser.guard';
import { InquiryComponent } from '../details/inquiry/inquiry.component';

const productRoutes: Routes = [
   { path: 'details/:id', component: DetailsComponent, canActivate: [PremiumUser]},
   { path: 'details', component: DetailsComponent, canActivate: [PremiumUser] },
   { path: 'inquiry/:id', component: InquiryComponent, canActivate: [StandardUser] },
];

@NgModule({
  imports: [RouterModule.forChild(productRoutes)],
  exports: [RouterModule]
})
export class HomeRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/home/home.routes.ts